import Home from './Pages/Home/Home';
import Auth from './Pages/Auth/Auth';
import PostAd from './Pages/PostAd/PostAd';
import Dashboard from './Pages/Dashboard/Dashboard';
import Notification from './Pages/Notification/Notification';
import ViewAd from './Pages/ViewAd/ViewAd';
import Cart from './Pages/Cart/Cart';
import Checkout from '../src/Pages/CheckoutPage/Checkout';
import ViewBook from './Pages/ViewBook/ViewBook';
import SearchResult from './Pages/SearchResult/SearchResult';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import { useSelector } from 'react-redux';
import MyOrders from './Pages/MyOrders/MyOrders';
import EditBook from './Pages/EditBook/EditBook';
import PaymentSuccess from './Pages/PaymentSuccess/PaymentSuccess';
import DevelopersInfo from './Pages/DevelopersInfo/DevelopersInfo';
import Verify from './Pages/Verify/Verify';
import './App.css';



function App() {
  const user = useSelector(state => state);
  const router = createBrowserRouter([
  {
    path: "*",
    element: <>
    { <Home/>}
    </>
  },
  {
    path: "/home",
    element: <>
    { <Home/>}
    </>,
    exact: true,
  },
  {
    path: "/auth",
    element: <Auth />,
    exact: true
  },
  {
    path: "/postAd",
    element:<>
    {/* {user.token?  <PostAd/> : <Navigate to="../ auth" />} */}
    <PostAd/> 
    </>,
    exact: true
  },
  {
    path: "/dashboard",
    element:<>
    <Dashboard/>
    </>,
    exact: true
  },
  {
    path: "/dashboard/viewAd/:id",
    element:<>
    <ViewAd/>
    </>,
    exact: true
  },
    {
    // User Route For notifiation
    path: "/dashboard/notification",
    element: <>
      <Notification />
    </>,
  },
  {
    path: "/cart",
    element: <>
      <Cart />
    </>,
  },
  {
    path: "/checkout",
    element: <>
      <Checkout /> 
    </>,
  },
  {
    path: "/viewbook/:id",
    element: <>
      <ViewBook />
    </>,
    },
  {
    path: "/search-result/:category_id/:category_name/:title/:location",
    element: <>
      <SearchResult />
    </>,
  },
  {
    path: "/orders",
    element: <>
      <MyOrders/>
    </>,
    exact: true
  },
  {
    path: "/dashboard/EditBook/:id",
    element:<>
      <EditBook/>
    </>,
    exact: true
  },
  {
    path: "/paymentsuccess",
    element:<>
      <PaymentSuccess/>
    </>,
    exact: true
  },
  {
    path: "/developersInfo",
    element:<>
      <DevelopersInfo/>
    </>,
    exact: true
  },
  {
    path: "/user/verify/:token",
    element:<>
      <Verify/>
    </>,
    exact: true
  },

]);
return (
    <div className="App">
      <RouterProvider  router={router} />
    </div>
  );
}

export default App;
  